<template>
  <div class="bq-product-yhf">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <div class="left-quotes quotes">
      <img
        src="https://img.alicdn.com/tfs/TB1urwkCEz1gK0jSZLeXXb9kVXa-76-68.png"
        alt=""
      />
    </div>
    <p class="title-desc">
      医后付是基于信用医疗的先诊疗后付费产品利用互联网金融普惠支付和风控技术，结合医疗领域的特殊场景，为患者提供更加高效便捷的支付方式，为符合信用条件的患者提供一定的信用额度，达到“诊间记账，诊后一次性结算”先诊疗后付费目的，减少患者支付次数和等候时间。
      <br />
      <br />
      签约医后付的持卡人在就诊流程中无需主动进行付费，医院业务系统将根据签约的支付渠道，自动发起支付交易，持卡人在院内就诊、检查、取药等环节无需多次排队、多次缴费，整个诊疗结束后，持卡人可直接离院，费用由医院业务系统完成收费交易，实现无感支付。
    </p>
    <div class="right-quotes quotes">
      <img
        src="https://img.alicdn.com/tfs/TB1H3IhCqL7gK0jSZFBXXXZZpXa-76-68.png"
        alt=""
      />
    </div>
    <div class="yhf-descs">
      <img
        src="https://img.alicdn.com/tfs/TB1qzg3E.T1gK0jSZFrXXcNCXXa-1450-558.png"
        alt=""
        :style="{ width: '725px', height: '282px' }"
      />
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="yhf-adv">
      <InfoBox
        :col="3"
        :itemObj="item"
        v-for="item in datalist"
        :key="item.advTitles"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'yhf',
  data() {
    return {
      rightArrow:
        'https://img.alicdn.com/tfs/TB1VDuoDUY1gK0jSZFMXXaWcVXa-36-16.png',
      datalist: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1UetTEbH1gK0jSZFwXXc7aXXa-84-92.png',
          advTitles: '无需多次排队',
          advDesc:
            '提升用户支付体验，无需多次排队缴纳费用，解决目前看病反复、付费反复排队的痛点；',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1ZTtPEkP2gK0jSZPxXXacQpXa-84-84.png',
          advTitles: '信用体系完备',
          advDesc: '依托支付宝产品-芝麻信用与蚂蚁花呗，拥有较完备的信用体系；',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1GuVHEeL2gK0jSZPhXXahvXXa-74-84.png',
          advTitles: '支持刷脸支付',
          advDesc: '支持“刷脸” 开通信用就医，实现诊疗费用“最多付一次”。',
        },
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
.bq-product-yhf {
  .title-desc {
    color: #333;
    font-size: 18px;
  }

  .quotes {
    &.left-quotes {
      margin-bottom: 20px;
    }
    &.right-quotes {
      text-align: right;
      margin-top: 20px;
    }
    img {
      width: 28px;
      height: 25px;
    }
  }

  .yhf-descs {
    display: flex;
    justify-content: center;
    padding-top: 54px;
    padding-bottom: 90px;
    color: #333;

    & > div {
      width: 300px;
      & > div {
        min-height: 150px;
        margin-bottom: 60px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    h3 {
      font-size: 20px;
      margin-bottom: 20px;
    }
    p {
      font-size: 18px;
    }
    .descs-left {
      margin-left: 35px;
      margin-right: 38px;
    }
    .descs-mid {
      padding: 0 35px 0 38px;
      width: 335px;
      flex: 0 0 325px;
      border-left: 2px solid #aeaeae;
      border-right: 2px solid #aeaeae;
      margin-bottom: 0;
    }

    .descs-right {
      margin-left: 38px;
    }
  }

  .yhf-adv {
    display: flex;
    justify-content: space-between;
    .bq-infobox {
      width: 252px !important;
    }
  }

  /deep/ .bq-infobox {
    p {
      font-size: 18px;
    }
  }

  /deep/ .header-title {
    margin-bottom: 60px;
    padding-bottom: 0;
  }
}
</style>
